import jwtDecode from "jwt-decode";
import type { IJwtPayload } from "~/utils/interfaces/auth-interfaces";

/**
 * The SDK maps the `/auth/teams/*` responses, but the token's own claims never pass through it:
 * they are decoded in the browser and keep the snake_case names orders mints them with.
 */
export function toJwtPayload(claims: unknown): IJwtPayload {
  const raw = (claims ?? {}) as Record<string, any>;
  return {
    sub: raw.sub,
    email: raw.email,
    name: raw.name,
    roles: raw.roles ?? [],
    companyId: raw.company_id,
    logAsAdminSub: raw.log_as_admin_sub,
    // The zone orders stores on the user; a Log As token carries the target's.
    timezone: raw.timezone ?? null,
    exp: raw.exp,
    iat: raw.iat,
  };
}

/** `null` when the token cannot be decoded, so the caller falls back to the browser's zone. */
export function accessTokenTimezone(accessToken: string | null | undefined): string | null {
  if (!accessToken) return null;
  try {
    return toJwtPayload(jwtDecode(accessToken)).timezone ?? null;
  } catch {
    return null;
  }
}
